// extracted by mini-css-extract-plugin
export var body = "_36-1";
export var bodyPadded = "_36-2";
export var chevron = "_36-4";
export var chevronOpen = "_36-5";
export var header = "_36-0";
export var icon = "_36-3";